import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import styled from 'styled-components';
import { Tooltip, Typography as MuiTypography, useTheme } from '@material-ui/core';
var StyledMuiTypography = styled(MuiTypography).withConfig({
  displayName: "Typography__StyledMuiTypography",
  componentId: "eka3xd-0"
})(["", " ", " ", ""], function (_ref) {
  var $variant = _ref.$variant,
      color = _ref.color;
  return $variant === 'overline' && !color ? "\n        && {\n          color: inherit;\n        }\n      " : '';
}, function (_ref2) {
  var $variant = _ref2.$variant;
  return $variant === 'overline2' ? "\n        && {\n          font-weight: 700;\n          font-size: 13px;\n          letter-spacing: 1.1px;\n          line-height: 16.32px;\n          text-transform: uppercase;\n        }\n      " : '';
}, function (_ref3) {
  var $variant = _ref3.$variant;
  return $variant === 'surtitle' ? "\n          && {\n            color: rgba(0, 0, 0, 0.54);\n            font-weight: 400;\n            font-size: 12px;\n            letter-spacing: 1.5px;\n            line-height: inherit;\n            text-transform: uppercase;\n          }\n        " : '';
});

var Typography = function Typography(_ref4) {
  var getBodySlot = _ref4.getBodySlot,
      body = _ref4.body,
      children = _ref4.children,
      color = _ref4.color,
      component = _ref4.component,
      display = _ref4.display,
      e2e = _ref4.e2e,
      gutterBottom = _ref4.gutterBottom,
      _ref4$tooltip = _ref4.tooltip,
      tooltip = _ref4$tooltip === void 0 ? '' : _ref4$tooltip,
      tooltipOpen = _ref4.tooltipOpen,
      variant = _ref4.variant,
      className = _ref4.className,
      _ref4$noWrap = _ref4.noWrap,
      noWrap = _ref4$noWrap === void 0 ? false : _ref4$noWrap;
  var bodyCb = React.useCallback(function (node) {
    getBodySlot && getBodySlot(node);
  }, [getBodySlot]);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Tooltip, {
    arrow: true,
    title: tooltip,
    open: tooltipOpen,
    PopperProps: _objectSpread(_objectSpread({}, e2e && {
      'data-e2e': "".concat(e2e, "-tooltip")
    }), {}, {
      modifiers: {
        offset: {
          enabled: true,
          offset: "0, -".concat(theme.spacing(1))
        }
      }
    })
  }, /*#__PURE__*/React.createElement(StyledMuiTypography, _extends({
    color: color
  }, component && {
    component: component
  }, {
    display: display
  }, e2e && {
    'data-e2e': e2e
  }, {
    gutterBottom: gutterBottom
  }, variant !== 'overline2' && variant !== 'surtitle' && {
    variant: variant
  }, {
    $variant: variant,
    className: className,
    noWrap: noWrap
  }), /*#__PURE__*/React.createElement("span", _extends({
    ref: bodyCb
  }, e2e && {
    'data-e2e': "".concat(e2e, "-body")
  }), body, children)));
};

export default Typography;

try {
  Typography.__docgenInfo = {
    description: '',
    displayName: 'Typography',
    methods: [],
    props: {
      body: {
        defaultValue: null,
        description: '',
        name: 'body',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      component: {
        defaultValue: null,
        description: '',
        name: 'component',
        required: false,
        type: {
          name: 'ElementType<any>'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      getBodySlot: {
        defaultValue: null,
        description: '',
        name: 'getBodySlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      tooltip: {
        defaultValue: {
          value: ''
        },
        description: '',
        name: 'tooltip',
        required: false,
        type: {
          name: 'string'
        }
      },
      tooltipOpen: {
        defaultValue: null,
        description: '',
        name: 'tooltipOpen',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      variant: {
        defaultValue: null,
        description: '',
        name: 'variant',
        required: false,
        type: {
          name: 'enum',
          raw: '"inherit" | Variant | "surtitle" | "overline2"',
          value: [{
            value: '"inherit"'
          }, {
            value: '"button"'
          }, {
            value: '"caption"'
          }, {
            value: '"h1"'
          }, {
            value: '"h2"'
          }, {
            value: '"h3"'
          }, {
            value: '"h4"'
          }, {
            value: '"h5"'
          }, {
            value: '"h6"'
          }, {
            value: '"subtitle1"'
          }, {
            value: '"subtitle2"'
          }, {
            value: '"body1"'
          }, {
            value: '"body2"'
          }, {
            value: '"overline"'
          }, {
            value: '"srOnly"'
          }, {
            value: '"surtitle"'
          }, {
            value: '"overline2"'
          }]
        }
      },
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        required: false,
        type: {
          name: 'string'
        }
      },
      color: {
        defaultValue: null,
        description: '',
        name: 'color',
        required: false,
        type: {
          name: 'enum',
          raw: '"error" | "inherit" | "primary" | "secondary" | "textPrimary" | "textSecondary" | "initial"',
          value: [{
            value: '"error"'
          }, {
            value: '"inherit"'
          }, {
            value: '"primary"'
          }, {
            value: '"secondary"'
          }, {
            value: '"textPrimary"'
          }, {
            value: '"textSecondary"'
          }, {
            value: '"initial"'
          }]
        }
      },
      noWrap: {
        defaultValue: {
          value: false
        },
        description: '',
        name: 'noWrap',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      gutterBottom: {
        defaultValue: null,
        description: '',
        name: 'gutterBottom',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      display: {
        defaultValue: null,
        description: '',
        name: 'display',
        required: false,
        type: {
          name: 'enum',
          raw: '"block" | "inline" | "initial"',
          value: [{
            value: '"block"'
          }, {
            value: '"inline"'
          }, {
            value: '"initial"'
          }]
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map